import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTopThreeAgents = styled(Stack)`
  display: flex;
  flex-direction: rows;
  align-items: flex-start;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
  }
`;

export default StyledTopThreeAgents;
